import stripePersonListStore from '@modules/stripe/stripe-person/stripe-person-list-store';
import stripePersonViewStore from '@modules/stripe/stripe-person/stripe-person-view-store';
import stripePersonFormStore from '@modules/stripe/stripe-person/stripe-person-form-store';

export default {
  namespaced: true,

  modules: {
    form: stripePersonFormStore,
    list: stripePersonListStore,
    view: stripePersonViewStore
  },
};
